module.exports = __webpack_public_path__ + "img/nurture-icon.0986c6d3.png";